@use "foundation/_colors.scss";

.connection-header {
  background-color: colors.$primary-background-color;
  padding-top: 2em;

  .header-content {
    display: flex;
    justify-content: left;
    margin: 0 auto;
    max-width: 42em;
  }

  .nav-items {
    cursor: pointer;
  }
}
